<script>
    import { checkout_entrance } from '/srv/web/wyvr/html/releases/58819/gen/client/checkout/logic/actions.js?1733898724794';
    import AmazonPay from '/srv/web/wyvr/html/releases/58819/gen/client/checkout_buttons/AmazonPay.svelte?1733898724794';
    import PayPal from '/srv/web/wyvr/html/releases/58819/gen/client/checkout_buttons/PayPal.svelte?1733898724794';

    function checkout() {
        checkout_entrance();
    }
    function cart() {
        checkout_entrance('cart');
    }
</script>

<div class="m-cart__checkout">
    <button class="btn checkout-btn" on:click={checkout}>{window.__('cart.proceed_to_checkout')}</button>
    <AmazonPay />
    <PayPal />
</div>
<button class="btn cart-btn" on:click={cart}>{window.__('cart.view_cart')}</button>


<style>
    .btn {
        display: block;
        width: 100%;
    }
    .checkout-btn {
        border: 1px solid #71c062;
        color: #fff;
        background: #71c062;
        height: 72px;
        font-size: 1.3rem;
        transition: all 0.8s ease-in-out;
    }
    .checkout-btn:hover {
        color: #fff;
        background: #707070;
        height: 72px;
        font-size: 1.3rem;
    }
    .cart-btn {
        text-align: center;
        border: none;
        text-transform: unset !important;
        padding: var(--space);
        padding: 16px;
        width: 100%;
        display: block;
        background-color: transparent;
        color: #707070;
        font-size: 1rem !important;
        font-weight: 400;
        line-height: 1.8;
    }
</style>